"use strict";
import "./libraries/modernizr";

import $ from "jquery";
window.jQuery = window.$ = $;

// определение входа элемента в экран
import "./plugins/isInViewPort";
// карусель
import "slick-carousel";
// модальные окнка и галерея
import "@fancyapps/fancybox";
// слайдер диапазонов
import "ion-rangeslider";
// маска для телефона
import Cleave from "cleave.js";

import "components/main/main";
import "components/modal/modal";
import "components/gallery/gallery";
// import "components/nav/nav";
// import "components/main/types/types";
// import "components/page/share/share";
// import "components/page/gallery/gallery";
// import "components/main/feedback/feedback";
// import "components/main/calculator/calc";

// убираем автофокус с элементов
$.fancybox.defaults.autoFocus = false;
$.fancybox.defaults.backFocus = false;
$.fancybox.defaults.lang = "ru";
$.fancybox.defaults.i18n = {
  ru: {
    CLOSE: "Закрыть",
    NEXT: "Следущее изображение",
    PREV: "Предыдущее изображение",
    ERROR: "Загрузка контента не удалась. <br/> Пожалуйста повторите позднее.",
    PLAY_START: "Запустить слайдшоу",
    PLAY_STOP: "Остановить слайдшоу",
    FULL_SCREEN: "На полный экран",
    THUMBS: "Миниатюры",
    DOWNLOAD: "Скачать",
    SHARE: "Поделиться",
    ZOOM: "Увеличить"
  }
};

// ленивая подгрузка картинок 
var imgActive = false;

/* Polyfill for .closets */
(function(ELEMENT) {
    ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
    ELEMENT.closest = ELEMENT.closest || function closest(selector) {
        if (!this) return null;
        if (this.matches(selector)) return this;
        if (!this.parentElement) {return null}
        else return this.parentElement.closest(selector)
      };
}(Element.prototype));

function lazyLoad() {
	if (imgActive === false) {
		imgActive = true;
		var lazyImages = [].slice.call(document.querySelectorAll("img[data-src]"));
		setTimeout(function () {
			lazyImages.forEach(function (lazyImage) {
				if (
					lazyImage.getBoundingClientRect().top <= window.innerHeight &&
					lazyImage.getBoundingClientRect().right <= window.innerWidth &&
					lazyImage.getBoundingClientRect().left >= 0 &&
					lazyImage.getBoundingClientRect().bottom >= 0 &&
					getComputedStyle(lazyImage).display !== "none" &&
					typeof lazyImage.dataset.src != 'undefined'
				) {					
					lazyImage.src = lazyImage.dataset.src;
					lazyImage.removeAttribute("data-src");
					if (lazyImage.dataset.srcset) {
						lazyImage.srcset = lazyImage.dataset.srcset;
						lazyImage.removeAttribute("data-srcset");
					}
					if (lazyImage.parentElement.classList.contains("img-lazy")) {
						lazyImage.closest(".img-lazy").classList.remove("img-lazy");
					}

					lazyImages = lazyImages.filter(function (image) {
						return image !== lazyImage;
					});

					if (lazyImages.length === 0) {
						document.removeEventListener("scroll", lazyLoad);
						window.removeEventListener("resize", lazyLoad);
						window.removeEventListener("orientationchange", lazyLoad);
					}
				}
			});
			imgActive = false;
		}, 200);
	}
}

if (document.addEventListener) {
	document.addEventListener("DOMContentLoaded", lazyLoad);
} else {
	if (window.addEventListener) {
		window.addEventListener("load", lazyLoad);
	} else if (window.attachEvent) {
		window.attachEvent("onload", lazyLoad);
	}
}
document.addEventListener("scroll", lazyLoad);
window.addEventListener("resize", lazyLoad);
window.addEventListener("orientationchange", lazyLoad);

$(() => {
    // запуск маски для телефона
    $("body").on("focus", ".js-mask-phone", function() {
		var cleave = new Cleave(this, {
            prefix: "+7",
            delimiters: [" ", " ", " "],
            blocks: [2, 3, 3, 2, 2]
        });
    });
    // убираем с поля для телефона любые символы кроме цифр
    $(".js-mask-phone").on("keydown", function(e) {
        if (e.key.length == 1 && e.key.match(/[^0-9'".]/)) {
            return false;
        }
    });
    // плавный скролл при клике
    $('.js-smoothLink[href^="#"]').click(function () {
        $('html, body').animate({
            scrollTop: $('[id="' + $.attr(this, 'href').substr(1) + '"]').offset().top
        }, 500);
        return false;
    });

    // переключение табов
    $('body').on('click', '.js-tabs-btn', function () {
        let btnId = $(this).data('target');

        $(this).addClass('tabs-btn--active').siblings().removeClass('tabs-btn--active');
        $(this).closest('.tabs-container').find('.tabs-body').hide().removeClass('tabs-body--active');
        $('#' + btnId).fadeIn('slow').addClass('tabs-body--active');
    });
});
